import 'swiper/css';
import 'swiper/css/autoplay';

import { Box, Paper } from '@mui/material';
import { useRouter } from 'next/router';
import { Autoplay } from 'swiper/modules';
import NextLink from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';
import NextImage from 'next/image';

export default function Banner({ appData }) {
  const router = useRouter();
  const { asPath } = router;
  const [useSlider, setUseSlider] = useState(false);

  useEffect(() => {
    const tm = setTimeout(() => {
      setUseSlider(true);
    }, 2000);

    return () => {
      clearTimeout(tm);
    };
  }, [setUseSlider]);

  if (!appData?.banners.data.length) {
    return null;
  }

  const banners = appData.banners.data.filter((item) => {
    const {
      excludedUrls = [],
      includedUrls = [],
    } = item.attributes;

    if (excludedUrls.length > 0) {
      const match = excludedUrls.find(({ url }) => asPath.startsWith(url));

      if (match) {
        return false;
      }
    }

    if (includedUrls.length > 0) {
      const match = includedUrls.find(({ url }) => asPath.startsWith(url));

      if (!match) {
        return false;
      }
    }

    return true;
  });

  if (banners.length === 0) {
    return null;
  }

  return (
    <Box mb={1} mt={3}>
      {banners.length === 1 ? (
        <Box display="flex" justifyContent="center" pb={2}>
          <BannerItem item={banners[0]} />
        </Box>
      ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {!useSlider ? (
            <Box display="flex" justifyContent="center" pb={2}>
              <BannerItem item={banners[0]} />
            </Box>
          ) : (
            <Swiper
              autoHeight
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop
              modules={[Autoplay]}
            >
              {banners.map((item) => (
                <SwiperSlide key={item.id}>
                  <Box display="flex" justifyContent="center" pb={2}>
                    <BannerItem item={item} />
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </>
      )}
    </Box>
  );
}

function BannerItem({ item }) {
  const imageDesktop = item.attributes.fileDesktop.data.attributes.formats.large
    ?? item.attributes.fileDesktop.data.attributes;
  const imageMobile = item.attributes.fileMobile.data.attributes.formats.large
    ?? item.attributes.fileMobile.data.attributes;

  return (
    <Paper elevation={5} sx={{ overflow: 'hidden' }}>
      <Box
        component={NextLink}
        href={item.attributes.url ?? '#'}
        sx={{ display: 'block' }}
      >
        {item.attributes.fileDesktop && (
          <Box
            sx={{
              display: {
                md: 'block',
                xs: 'none',
              },
            }}
          >
            <NextImage
              alt={item.attributes.fileDesktop.data.attributes.alternativeText || 'Banner'}
              className="img-fluid"
              height={imageDesktop.height}
              src={imageDesktop?.url}
              style={{ display: 'block' }}
              width={imageDesktop.width}
            />
          </Box>
        )}
        {item.attributes.fileMobile && (
          <Box
            sx={{
              display: {
                md: 'none',
                xs: 'block',
              },
            }}
          >
            <NextImage
              alt={item.attributes.fileMobile.data.attributes.alternativeText || 'Banner'}
              className="img-fluid"
              height={imageMobile.height}
              src={imageMobile?.url}
              style={{ display: 'block' }}
              width={imageMobile.width}
            />
          </Box>
        )}
      </Box>
    </Paper>
  );
}
